import Terms from '@pages/terms'

const TermsPage = () => <Terms />

export const getStaticProps = () => ({
  props: {
    breadcrumbs: [{ label: 'Terms of service' }],
  },
})

export default TermsPage
